import { FunctionComponent } from "react";
import { getActiveSite } from "../../selectors/sites.js";
import { useAppSelector } from "../../store/hooks.js";
import styles from "../../stylesheets/components/google-360-virtual-tour-module.module.css";
import moduleBaseStyles from "../../stylesheets/components/module-base.module.css";
import {
  BaseModuleProps,
  Google360VirtualTourModuleSettings,
} from "../../types/index.js";
import { getActiveColorScheme } from "../../utils/utils.js";
import EmbeddedGoogleMaps from "../EmbeddedGoogleMaps.js";
import ModuleHeadings from "../ModuleHeadings.js";
import ModuleWithHeadings from "../ModuleWithHeadings.js";

type Props = BaseModuleProps<Google360VirtualTourModuleSettings>;

const Google360VirtualTourModule: FunctionComponent<Props> = ({
  translatedModule: {
    id,
    settings: { textAlign, url },
    translation: {
      settings: { title, subtitle },
    },
  },
  translatedModule,
  isFirstOnPage,
  isActive,
  isPreview,
}) => {
  const scheme = useAppSelector((state) =>
    getActiveColorScheme(
      state.colorSchemes,
      getActiveSite(state.sites),
      translatedModule,
    ),
  );

  return (
    <ModuleWithHeadings
      title={title}
      subtitle={subtitle}
      id={id}
      className={styles.Google360VirtualTourModule}
      colors={{ background: scheme.main.background, color: scheme.main.text }}
    >
      <div className={moduleBaseStyles.Module__Wrapper}>
        <ModuleHeadings
          scheme={scheme}
          isFirstOnPage={isFirstOnPage}
          textAlign={textAlign}
          title={title}
          subtitle={subtitle}
        />
      </div>

      <div className={moduleBaseStyles.Module__Wrapper}>
        <EmbeddedGoogleMaps
          isActive={isActive}
          isPreview={isPreview}
          placeholder="Google 360°"
          url={url}
          className={styles.Google360VirtualTourModule__Container}
        />
      </div>
    </ModuleWithHeadings>
  );
};

export default Google360VirtualTourModule;
